import { render, staticRenderFns } from "./CredentialButton.vue?vue&type=template&id=52ea7e0c"
import script from "./CredentialButton.vue?vue&type=script&lang=js"
export * from "./CredentialButton.vue?vue&type=script&lang=js"
import style0 from "./CredentialButton.vue?vue&type=style&index=0&id=52ea7e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports